export enum IssueTypeCategoryEnum {
  CONTROL = 'CONTROL',
  CONTROL_GROUP = 'CONTROL_GROUP',
  INFO_REQUEST = 'INFO_REQUEST',
  SUB_TASK = 'SUB_TASK',
  TASK = 'TASK',
}
